import { Link } from "react-router-dom";
import { History as HistoryIcon, Trash2, X } from "lucide-react";
import { getHistory, clearHistory, removeHistory } from "@/lib/storage";
import { findCalculator } from "@/lib/calculators";
import { useEffect, useState } from "react";
import { toast } from "sonner";

export default function History() {
  const [items, setItems] = useState([]);
  useEffect(() => setItems(getHistory()), []);

  const doClear = () => { clearHistory(); setItems([]); toast.success("History cleared"); };
  const doRemove = (id) => { removeHistory(id); setItems(getHistory()); };

  return (
    <div data-testid="history-page">
      <div className="mb-6 flex items-end justify-between gap-4 flex-wrap">
        <div><div className="overline mb-2">Recent</div><h1 className="text-3xl sm:text-4xl font-black tracking-tighter">History</h1><p className="text-muted-foreground mt-2 text-sm">Last 50 calculations, stored locally on this device.</p></div>
        {items.length > 0 && (
          <button data-testid="clear-history-btn" onClick={doClear} className="h-10 px-3 rounded-md border border-border bg-card hover:bg-destructive/10 hover:border-destructive/40 hover:text-destructive text-sm font-medium flex items-center gap-1.5 transition">
            <Trash2 className="h-4 w-4" strokeWidth={1.75} /> Clear all
          </button>
        )}
      </div>

      {items.length === 0 ? (
        <div className="rounded-lg border border-dashed border-border p-12 text-center" data-testid="history-empty">
          <HistoryIcon className="w-8 h-8 text-muted-foreground mx-auto mb-3" strokeWidth={1.5} />
          <div className="font-medium">No calculations yet</div>
          <div className="text-sm text-muted-foreground mt-1">Your recent work will appear here automatically.</div>
        </div>
      ) : (
        <div className="rounded-lg border border-border bg-card divide-y divide-border" data-testid="history-list">
          {items.map((h) => {
            const calc = findCalculator(h.slug);
            if (!calc) return null;
            return (
              <div key={h.id} data-testid={`history-item-${h.id}`} className="p-4 flex items-center gap-4 hover:bg-accent/40 transition">
                <div className="w-9 h-9 rounded-md bg-primary/10 flex items-center justify-center shrink-0">
                  <calc.Icon className="w-4 h-4 text-primary" strokeWidth={1.75} />
                </div>
                <div className="flex-1 min-w-0">
                  <Link to={`/${h.slug}`} className="font-medium text-sm hover:text-primary transition">{h.title}</Link>
                  <div className="text-xs text-muted-foreground truncate">
                    {Object.entries(h.inputs || {}).map(([k, v]) => `${k}: ${v}`).join(" · ")}
                  </div>
                </div>
                <div className="text-[11px] text-muted-foreground hidden sm:block">{new Date(h.ts).toLocaleString()}</div>
                <button data-testid={`remove-history-${h.id}`} onClick={() => doRemove(h.id)} aria-label="Remove" className="h-8 w-8 rounded-md hover:bg-destructive/10 hover:text-destructive flex items-center justify-center transition">
                  <X className="h-4 w-4" />
                </button>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
